var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 281,
    viewBox: "0 0 219 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.082 58.0488L0.600052 70.4067L23.9979 47.8463H66.082V58.0488Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 158.85C114.521 192.407 113.312 225.971 112.111 259.527C113.742 260.612 116.305 262.629 118.33 265.957C121.825 271.71 121.359 277.493 121.119 279.459H53.1681C51.9957 276.823 47.9249 266.846 52.3088 258.668C58.0254 248.007 76.6534 243.084 95.245 252.507C96.7014 221.288 98.1651 190.069 99.6216 158.85H115.737H115.73Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.315 158.849C130.845 192.406 138.375 225.969 145.905 259.526C144.274 260.611 141.71 262.628 139.686 265.956C136.19 271.709 136.656 277.491 136.897 279.458H204.855C205.838 277.302 210.185 267.209 205.714 258.667C200.172 248.086 182.709 242.966 165.509 251.224C156.457 220.428 147.412 189.638 138.36 158.842H123.315V158.849Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.567 168.422L128.272 180.543L145.087 182.618L139.891 166.394L125.567 168.422Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9413 179.56L114.381 185.407L114.923 170.173L99.9872 168.09L98.9413 179.56Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.579 130.871C166.978 136.937 179.409 144.868 195.393 145.355C196.915 145.399 215.667 145.785 217.895 138.699C219.359 134.061 212.703 129.48 202.952 117.625C195.306 108.332 190.07 99.8196 186.749 93.8481",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.579 130.871C166.978 136.937 179.409 144.868 195.393 145.355C196.915 145.399 215.667 145.785 217.895 138.699C219.359 134.061 212.703 129.48 202.952 117.625C195.306 108.332 190.07 99.8196 186.749 93.8481",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.313 17.5888C166.426 24.9147 207.418 95.6545 179.825 141.824C156.041 181.621 94.8777 180.427 59.6535 165.149C29.1918 151.932 2.99031 121.623 8.79425 110.751C12.8796 103.111 32.5198 105.573 48.4315 108.843C48.1767 101.451 48.3878 92.8217 49.5676 83.2747C50.9512 72.0673 53.3325 62.3528 55.8303 54.4078C59.3258 48.4218 70.8827 30.3983 94.0038 21.7033C96.9022 20.6109 112.763 14.8652 127.306 17.5888H127.313Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.455 99.8554H162.448C154.054 99.8554 147.25 93.051 147.25 84.6573V81.9046C147.25 73.511 154.054 66.7066 162.448 66.7066H162.455C170.848 66.7066 177.653 73.511 177.653 81.9046V84.6573C177.653 93.051 170.848 99.8554 162.455 99.8554Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M163.912 92.1586C160.132 92.1586 157.067 87.8027 157.067 82.4295C157.067 77.0563 160.132 72.7004 163.912 72.7004C167.693 72.7004 170.758 77.0563 170.758 82.4295C170.758 87.8027 167.693 92.1586 163.912 92.1586Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M161.603 69.7742L164.21 77.4642L155.282 76.0005L161.603 69.7742Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.705 100.693H134.698C126.304 100.693 119.5 93.8889 119.5 85.4952V82.7425C119.5 74.3489 126.304 67.5445 134.698 67.5445H134.705C143.098 67.5445 149.903 74.3489 149.903 82.7425V85.4952C149.903 93.8889 143.098 100.693 134.705 100.693Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.159 93.0034C132.379 93.0034 129.314 88.6475 129.314 83.2743C129.314 77.9011 132.379 73.5452 136.159 73.5452C139.94 73.5452 143.005 77.9011 143.005 83.2743C143.005 88.6475 139.94 93.0034 136.159 93.0034Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.852 70.6177L136.459 78.3078L127.531 76.8441L133.852 70.6177Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.617 55.6521L133.546 53.48C135.857 53.0592 138.071 54.5914 138.492 56.9021L138.673 57.898C139.094 60.2088 137.562 62.4231 135.251 62.8439L123.322 65.016C121.012 65.4368 118.797 63.9047 118.377 61.5939L118.195 60.598C117.774 58.2873 119.307 56.0729 121.617 55.6521Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M169.353 61.6959L157.381 59.516C155.082 59.0973 153.558 56.8944 153.976 54.5955L154.165 53.5566C154.584 51.2577 156.787 49.7334 159.086 50.152L171.058 52.332C173.357 52.7506 174.881 54.9536 174.462 57.2525L174.273 58.2913C173.854 60.5902 171.651 62.1145 169.353 61.6959Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5613 51.6688C54.0186 52.7393 36.1917 55.7541 17.0102 63.1238C11.0971 65.3958 5.62809 67.8645 0.610626 70.3987C0.719856 65.7454 1.79762 62.0897 3.17397 59.2278C11.0606 42.8136 36.9927 35.4221 67.9277 39.4929C68.1389 43.5491 68.3501 47.6053 68.5613 51.6615V51.6688Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M161.661 38.8881C150.22 9.16927 118.412 -5.68651 91.897 3.11773C70.276 10.298 54.9541 32.2977 54.9905 57.4506C71.5067 51.6757 91.7076 46.0757 115.069 42.5584C132.175 39.9877 147.861 38.9974 161.661 38.8881Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.713 31.292C142.302 20.7618 132.195 15.8609 125.619 18.4971C120.798 20.4341 117.485 26.5876 117.972 33.4766C126.886 32.7484 135.799 32.0202 144.713 31.292Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.649 30.4399C144.424 31.4521 131.2 32.4644 117.968 33.4766C112.455 32.9814 108.545 35.9016 108.326 38.7053C108.151 40.9191 110.3 42.776 110.853 43.2203",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.15 101.076L130.165 139.864L122.392 159.507L24.3765 120.72L32.15 101.076Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2715 105.034L38.0018 113.299",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1794 108.303L45.9097 116.561",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1816 111.317L53.9119 119.582",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1597 114.413L61.8899 122.679",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1528 117.465L69.8831 125.73",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1182 120.581L77.8484 128.839",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9866 123.946L85.7169 132.211",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9548 127.032L93.6851 135.298",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.751 130.594L101.481 138.86",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M112.546 134.148L109.277 142.406",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M120.54 137.199L117.27 145.457",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M109.44 107.822C105.944 126.552 94.5329 140.629 79.9029 144.168C71.6958 146.156 59.6146 145.712 56.8036 140.002C54.9976 136.339 57.8304 132.21 64.6612 119.583C69.9991 109.708 74.1135 101.428 76.8735 95.7044",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109.44 107.822C105.944 126.552 94.5329 140.629 79.9029 144.168C71.6958 146.156 59.6146 145.712 56.8036 140.002C54.9976 136.339 57.8304 132.21 64.6612 119.583C69.9991 109.708 74.1135 101.428 76.8735 95.7044",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M149.715 93.4318C162.299 94.1891 176.324 96.0898 177.045 101.399C177.344 103.62 175.225 105.702 173.586 107.304C164.527 116.182 151.069 112.81 148.004 111.958",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M149.715 93.4318C162.299 94.1891 176.324 96.0898 177.045 101.399C177.344 103.62 175.225 105.702 173.586 107.304C164.527 116.182 151.069 112.81 148.004 111.958",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M150.066 104.532C152.309 105.027 154.792 105.413 157.494 105.573C165.446 106.039 172.153 104.372 176.988 102.588",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.eac01478d71dc5c6fbfedec095bf74cb.svg";
export { ForwardRef as ReactComponent };